/**
 * Serviço para consulta de CEP usando a API ViaCEP
 * API gratuita e pública para consulta de endereços por CEP
 */

/**
 * Consulta um CEP na API ViaCEP
 * @param {string} cep - CEP no formato XXXXX-XXX ou XXXXXXXX
 * @returns {Promise<Object>} Dados do endereço ou erro
 */
export const consultarCEP = async (cep) => {
  try {
    // Remove formatação do CEP (hífens, espaços, etc.)
    const cepLimpo = cep.replace(/\D/g, '');
    
    // Valida se o CEP tem 8 dígitos
    if (cepLimpo.length !== 8) {
      return {
        success: false,
        error: 'CEP deve ter 8 dígitos'
      };
    }

    // Valida se o CEP não contém apenas zeros
    if (cepLimpo === '00000000') {
      return {
        success: false,
        error: 'CEP inválido'
      };
    }

    console.log('🔍 CEP Service: Consultando CEP:', cepLimpo);

    // Faz a requisição para a API ViaCEP
    const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
    
    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();

    // Verifica se o CEP foi encontrado
    if (data.erro) {
      return {
        success: false,
        error: 'CEP não encontrado'
      };
    }

    // Retorna os dados formatados
    return {
      success: true,
      data: {
        cep: data.cep,
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
        complemento: data.complemento || ''
      }
    };

  } catch (error) {
    console.error('❌ Erro ao consultar CEP:', error);
    return {
      success: false,
      error: 'Erro ao consultar CEP. Tente novamente.'
    };
  }
};

/**
 * Valida se um CEP está no formato correto
 * @param {string} cep - CEP a ser validado
 * @returns {boolean} True se o CEP é válido
 */
export const validarCEP = (cep) => {
  const cepLimpo = cep.replace(/\D/g, '');
  return cepLimpo.length === 8 && cepLimpo !== '00000000';
};

/**
 * Formata um CEP para exibição (XXXXX-XXX)
 * @param {string} cep - CEP a ser formatado
 * @returns {string} CEP formatado
 */
export const formatarCEP = (cep) => {
  const numbers = cep.replace(/\D/g, '');
  if (numbers.length <= 5) return numbers;
  return numbers.replace(/(\d{5})(\d{0,3})/, '$1-$2');
};

